import { GcReducedPrice, GcLoader } from '@garmin/components-global';

export default {
  name: 'ProductCard',
  components: {
    GcReducedPrice,
    GcLoader,
  },
  props: {
    imageSrc: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    price: {
      type: String,
      default: '',
    },
    salePrice: {
      type: String,
      default: '',
    },
    priceHtml: {
      type: String,
      default: '',
    },
    salePriceHtml: {
      type: String,
      default: '',
    },
    priceLoading: {
      type: Boolean,
      default: false,
    },
    gaEvent: {
      type: String,
      default: '',
    },
  },
  computed: {
    isDiscountedPrice() {
      return this.price && this.salePrice;
    },
  },
};
